.v4-progress-bar {
  width: 100%;
  height: var(--lab-ds-semantic-selectable-size-xxs);
  border-style: solid;
  background-color: var(--lab-ds-semantic-selectable-color-bg-default);
  border-width: var(--lab-ds-semantic-selectable-border-width-s);
  border-color: var(--lab-ds-semantic-selectable-color-border-default);
  border-radius: 1rem;
}

.progress-bar-completed {
  height: 100%;
  max-width: 100%;
  border-radius: 1rem;
  background-color: var(--lab-ds-semantic-selectable-color-primary-default);
}
